import { render, staticRenderFns } from "./WorkerTypeAddOrUpdate.vue?vue&type=template&id=aa4a035a&scoped=true&"
import script from "./WorkerTypeAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./WorkerTypeAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4a035a",
  null
  
)

export default component.exports